import { Inject, Injectable } from '@angular/core';
import { IResetPasswordPayload } from '@app/reset-password/models/reset-password';
import { Observable } from 'rxjs';
import { CORE_API_ROUTES } from '../configs/api-routes';
import { IPublicUser } from '../models/user';
import { HttpService } from './http.service';

@Injectable()
export class AuthService {
  constructor(@Inject(CORE_API_ROUTES) private apis, private http: HttpService) {}

  login$(username: string, password: string): Observable<{ token: string; refresh_token: string }> {
    return this.http.post<{ token: string; refresh_token: string }>(this.apis.auth.login, { username, password });
  }

  refreshToken$(token: string): Observable<{ token: string; refresh_token?: string }> {
    return this.http.post<{ token: string; refresh_token?: string }>(this.apis.auth.refreshToken, token);
  }

  me$(): Observable<IPublicUser> {
    return this.http.get<IPublicUser>(this.apis.auth.me);
  }

  logout$(): Observable<{ result: boolean }> {
    return this.http.post(this.apis.auth.logout);
  }

  sendResetPasswordLink$(email: string): Observable<{ result: boolean }> {
    return this.http.post(this.apis.auth.sendResetPasswordLink, { email });
  }

  verifyResetPasswordToken$(token: string): Observable<{ username: string; email: string; token: string }> {
    return this.http.post(this.apis.auth.verifyResetToken, { token });
  }

  resetPassword$(payload: IResetPasswordPayload): Observable<{ result: boolean }> {
    return this.http.post(this.apis.auth.resetPassword, payload);
  }

  verifyApprovalToken$(
    token: string,
    taskId: string,
  ): Observable<{ userName: string; email: string; approvalToken: string; taskId: number }> {
    return this.http.post(this.apis.auth.verifyApprovalToken(token), { taskId });
  }
}
